<template>
  <div>
    <div id="preload" style="display: none">
      <img src="./assets/images/backgrounds/home.jpg" />
      <img src="./assets/images/backgrounds/water-activities.jpg" />
      <img src="./assets/images/backgrounds/land-activities.jpg" />
      <img src="./assets/images/backgrounds/team-building.jpg" />
      <img src="./assets/images/backgrounds/about-us.jpg" />
      <img src="./assets/images/backgrounds/contact.jpg" />
    </div>
    <Header />
    <router-view />
    <Footer />
  </div>
</template>

<style lang="scss">
@import "./assets/styles/bootstrap/custom.scss";
@import "../node_modules/bootstrap/scss/bootstrap.scss";
</style>

<style lang="scss">
@media (max-width: 991.98px) {
  .masthead {
    h1 {
      font-size: 40px !important;
    }
  }
}

.masthead {
  color: #fff;

  h1 {
    font-size: 60px;
    color: #fff;
    line-height: 1.2;
    font-weight: 300;
  }

  h1.bread {
    font-weight: 700;
  }
}

.masthead {
  height: 100vh;
  min-height: 500px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.masthead-overlay {
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  height: 100vh;
  content: "";
  opacity: 0.4;
  background: #000000;
  background: #3e1f0f;
  background: -moz-linear-gradient(45deg, #3e1f0f 0%, #000000 100%);
  background: -webkit-gradient(
    left bottom,
    right top,
    color-stop(0%, #3e1f0f),
    color-stop(100%, #000000)
  );
  background: -webkit-linear-gradient(45deg, #3e1f0f 0%, #000000 100%);
  background: -o-linear-gradient(45deg, #3e1f0f 0%, #000000 100%);
  background: -ms-linear-gradient(45deg, #3e1f0f 0%, #000000 100%);
  background: linear-gradient(45deg, #3e1f0f 0%, #000000 100%);
}

.activity-image {
  width: 100%;
  min-height: 450px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  -ms-flex-item-align: stretch !important;
  -ms-grid-row-align: stretch !important;
  align-self: stretch !important;
}

@media (max-width: 767.98px) {
  .activity-image {
    min-height: 350px !important;
    background-position: top center !important;
  }
}

.activity-heading-section h2 {
  font-size: 40px;
  font-weight: 600;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.8);
  font-family: inherit;
}

.activity-heading-section p {
  font-size: 16px;
  line-height: 1.8;
  font-weight: 400;
  color: #999999;
}

.activity-spacer {
  margin-top: 100px !important;
}
@media (max-width: 767.98px) {
  .activity-spacer {
    margin-top: 50px !important;
  }
}
</style>


<script lang="ts">
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  }
}
</script>